import { ComponentFactoryResolver, Type, ComponentFactory } from '@angular/core';

export abstract class CoreComponentFactoryResolver implements ComponentFactoryResolver {
	abstract addComponentFactoryResolver(resolver: ComponentFactoryResolver): CoreComponentFactoryResolver;
	abstract resolveComponentFactory<T>(component: Type<T>): ComponentFactory<T>;
}
